import { Button, Modal } from 'antd';
import React from 'react';
import { CheckCircleTwoTone } from '@ant-design/icons';
import PrimaryButton from '../PrimaryButton';

interface InfoModalProps {
  visible: boolean;
  message: string | undefined;
  title?: string;
  onClose: () => void;
  onOk?: () => void;
}

const InfoModal: React.FC<InfoModalProps> = ({
  title,
  visible,
  message,
  onClose,
  onOk,
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      centered
      maskClosable={false}
      closeIcon={null}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Close
        </Button>,
        onOk !== undefined ? (
          <PrimaryButton key="ok" onClick={onOk} label={'OK'} />
        ) : null,
      ]}
    >
      <div className="flex flex-col items-center text-center">
        <div>
          <CheckCircleTwoTone
            twoToneColor="#52c41a"
            style={{ fontSize: '80px' }}
          />
        </div>
        <div className="font-semibold text-xl my-2">{title}</div>
        <div>{message}</div>
      </div>
    </Modal>
  );
};

export default InfoModal;
